import { z } from "zod";

export const createVehicleSchema = z.object({
    vehicleId: z.string().nonempty("Field is required"),
    deviceId: z.string().min(1, "Field is required"),
    maxSpeed: z.string().min(1, "Field is required"),
    drivingLicenseType: z.string().min(1, "Field is required"),
    purchaseAmount: z.string().min(1, "Field is required"),
    region: z.string().min(1, "Field is required"),
    registrationNo: z.string().min(1, "Field is required"),
    simCardNumber: z.string().min(1, "Field is required"),
    mileage: z.string().min(1, "Field is required"),
    fuelType: z.string().min(1, "Please type fuel type"),
    vehicleType: z.string().min(1, "Please type vehicle type"),
    department: z.string().min(1, "Please type department"),
    
  });


  export const initialValues={
        vehicleId: "",
        deviceId: "",
        maxSpeed: "",
        drivingLicenseType: "",
        purchaseAmount: "",
        region: "",
        registrationNo: "",
        simCardNumber: "",
        mileage:  "",
        fuelType:  "",
        vehicleType:  "",
        department:  "",
      }

export const licenseType=[
    {label:"Light Vehicle",value:"light_vehicle"},
    {label:"Heavy Trucks",value:"heavy_trucks"},
]
export const fuelType=[
    {label:"Petrol",value:"petrol"},
    {label:"Diesel",value:"diesel"},
]
export const department=[
    {label:"Operations",value:"oparations"},
]